import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { Location } from '@angular/common';
import { AppSettings } from '../../app/app.settings';
import { Product, ProductFav } from '../../models/product';
import { QuestionnairePage } from '../questionnaire/questionnaire';
import { AskPage } from '../ask/ask';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-product-detailed',
  templateUrl: 'product-detailed.html',
})
export class ProductDetailedPage {
  get currentLang() {
    let lang = localStorage.getItem('es-language') || AppSettings.DEFAULT_LANGUAGE;

    if (this.curCountry === 'uk') {
      lang = 'en';
    }
    return lang;
  }

  public curCountry: string;
  public currentProductId: number;
  public currentProductType: string;
  public currentProduct: Product = new Product();
  public isCurrentProductFav: boolean = false;

  constructor(private iab: InAppBrowser,
              public navCtrl: NavController,
              public navParams: NavParams,
              private dataService: DataProvider/*, public analyticsService: AnalyticsService*/) {
    this.currentProductId = +navParams.get('id');
    this.currentProductType = <string>navParams.get('type');

    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ionViewDidLoad() {
    this.dataService.getProductsByIDs([this.currentProductId]).subscribe(productsData => {
      if (productsData.length > 0) {
        this.currentProduct = productsData[0];        
        
        this.dataService.getProductsExtByIDs([this.currentProductId]).subscribe(productsExtData => {
          if (productsExtData.length > 0) {
            this.currentProduct.productExt = productsExtData[0];
          }
        });

        let favProds: ProductFav[] = this.dataService.getFavProducts();
        this.isCurrentProductFav = favProds.map(p => p.id).indexOf(this.currentProduct.id) !== -1;
      }
    });
  }

  public getProductName(currentProduct: Product): string {
    return currentProduct['name_' + this.currentLang] || currentProduct['name'] || "";
  }

  public getProductBenefits(currentProduct: Product): string[] {
    //let benefitsCount = currentProduct['benefits_' + this.currentLang + '_take_detail'] || currentProduct['benefits_take_detail'];
    let benefitsStr = currentProduct['benefits_' + this.currentLang] || currentProduct['benefits'] || "";
    return benefitsStr ? benefitsStr.trim().split('\n')/*.slice(0, benefitsCount ? +benefitsCount : Number.MAX_VALUE)*/ : [];
  }

  public backButtonClick() {
    this.navCtrl.pop();
  }

  public restartButtonClick() {
    this.navCtrl.push(QuestionnairePage, { restart: true });
  }

  public toggleFavProduct() {
    let favProds: ProductFav[] = this.dataService.getFavProducts();
    let currProdIndex = favProds.map(p => p.id).indexOf(this.currentProduct.id);
    if (currProdIndex === -1) {
      favProds.push(<ProductFav>{
        id: this.currentProduct.id,
        type: this.currentProductType
      });
      this.isCurrentProductFav = true;
    }
    else {
      favProds.splice(currProdIndex, 1);
      this.isCurrentProductFav = false;
    }
    this.dataService.setFavProducts(favProds);
  }

  public askAboutProduct() {    
    this.dataService.PRODUCT_ID_FOR_ASK = this.currentProductId;
    //this.navCtrl.push(AskPage, { product_id: this.currentProductId });
    this.navCtrl.parent.select(2);
  }

  public openUrl(url: any) {
    const browser = this.iab.create(url);
    browser.show();
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-detailed.ts